import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from '../Button';
import Modal from './BaseModal';
import { Brands } from './../../common/constants';

const ModalBody = styled.div`
  ${(props) => props.theme.type.base};
  margin: ${(props) => props.theme.whitespace.small} 0;
  text-align: center;
  ${(props) => (props.brand === Brands.Wireless || props.brand === undefined) && props.theme.type.optInNoticeModalText};
`;

const NoticeModalButton = styled(Button)`
  ${(props) => (props.brand === Brands.Wireless || props.brand === undefined) && props.theme.type.optInNoticeModalButton};
    &:hover, {
      border:  ${(props) => props.brand === Brands.Wireless && "none"};
      background-color: ${(props) => props.brand === Brands.Wireless && props.theme.colours.hover};
`;

const NoticeModalContainer = styled(Modal)`
  .Modal {
    ${(props) => (props.brand === Brands.Wireless || props.brand === undefined) && props.theme.type.optInNoticeModal};
    @media (max-width: 400px) {
      width: 100%;
      max-width: ${(props) => (props.brand === Brands.Wireless || props.brand === undefined) && '80vw'};
    }
  }
`;

const NoticeModal = ({ brand, text, onClose, ...props }) => (
  <NoticeModalContainer brand={brand} onClose={onClose} {...props}>
    <ModalBody brand={brand}>{text}</ModalBody>
    <NoticeModalButton brand={brand} block onClick={onClose}>
      OK
    </NoticeModalButton>
  </NoticeModalContainer>
);
NoticeModal.propTypes = {
  brand: PropTypes.string,
  text: PropTypes.string.isRequired,
  onClose: PropTypes.func
};
NoticeModal.defaultProps = {
  onClose: () => {}
};
export default NoticeModal;
